import { Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { PersonsList } from './Persons/persons-list';
import { AddPersonDialog, FormData } from './Persons/add-person-dialog';

import { useSnack } from 'shared/ui/snack';
import useConfirmDialog from 'hooks/confirm-dialog.hook';
import { useState } from 'react';
import { CompanyEmployeeDto, SupplierPermissions } from '@sr/dto';
import { CardPaperTitled } from 'shared/ui/card-paper';
import { companiesApi } from 'entities/company/api.slice';
import { useCompanyEmployee } from 'entities/company/company-persons.hook';
import { extractNestJsErrorMessage } from '../../shared/api/rtk-query';
import { useUserAuth } from 'features/auth';

const CompanyPersons = (props: { companyId: number; isSupplier: boolean }) => {
  const { companyId, isSupplier } = props;
  const { user: currentUser } = useUserAuth();
  const canDelete = !isSupplier || !!currentUser?.permissions.includes(SupplierPermissions.EDIT);

  const [isAddLinkOpen, setAddLinkOpen] = useState(false);

  const { showSuccess, showError } = useSnack();
  const showConfirmDeleteDialog = useConfirmDialog();

  const { collection } = useCompanyEmployee(companyId);
  const [addCompanyEmployee] = companiesApi.useAddCompanyEmployeeMutation();
  const [removeCompanyPerson] = companiesApi.useRemoveCompanyPersonMutation();

  const handleAddClick = () => {
    setAddLinkOpen(true);
  };

  const handleAddLinkClose = () => {
    setAddLinkOpen(false);
  };

  const handleSubmit = async (formData: FormData) => {
    try {
      const newLink = await addCompanyEmployee({
        companyId,
        data: {
          person: {
            firstName: formData.firstName,
            secondName: formData.secondName,
            middleName: formData.middleName,
          },
          position: formData.position,
        },
      }).unwrap();
      showSuccess('Сотрудник успешно добавлен');
      setAddLinkOpen(false);
    } catch (e) {
      showError(`Ошибка добавления сотрудника к фирме:${extractNestJsErrorMessage(e)}`);
    }
  };

  const handleDeleteLink = async (linkId: CompanyEmployeeDto) => {
    try {
      await showConfirmDeleteDialog({
        content: 'Удалить контакт?',
      });
      await removeCompanyPerson(linkId.id).unwrap();
      showSuccess('Связь успешно удалена');
    } catch (e) {
      showError(`Ошибка удаления сотрудника: ${extractNestJsErrorMessage(e)}`);
    }
  };

  return (
    <>
      <CardPaperTitled title="Сотрудники">
        <Box mt={1}>
          <PersonsList list={collection} onLinkDelete={handleDeleteLink} companyId={companyId} canDelete={canDelete} />
        </Box>
        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end' }}>
          <Button startIcon={<AddIcon />} onClick={handleAddClick} size={'small'}>
            Добавить
          </Button>
        </Box>
      </CardPaperTitled>

      <AddPersonDialog open={isAddLinkOpen} onClose={handleAddLinkClose} submit={handleSubmit} />
    </>
  );
};

export default CompanyPersons;
